import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import BrandOrdersTable from '../../components/blocks/BrandOrdersTable';

import {
  getBrandOrder,
  postBrandOrdersReturns,
  setBrandOrdersOffset,
  setBrandOrdersSearchById,
  setBrandOrdersSort,
  setBrandOrdersPerPage,
  cancelFulfillments,
  brandOrdersDownloadDocuments,
  getBrandOrdersAndFilters,
  fulfillOrder,
} from '../../store/actions/brandOrders';

function BrandOrdersContainer(props) {
  const { getBrandOrdersAndFilters } = props;

  useEffect(() => {
    getBrandOrdersAndFilters(true);
  }, [getBrandOrdersAndFilters]);

  return <BrandOrdersTable {...props} />;
}

const mapStateToProps = (state) => {
  const { data, isLoading, orderLoading, order, offset, search, perPage, sort, statusCount } = state.brandOrders;

  const { returnReasons } = state.systemProperties;
  const { supplierId } = state.role;

  return {
    data,
    isLoading,
    order,
    orderLoading,
    offset,
    search,
    perPage,
    sort,
    statusCount,
    returnReasons,
    supplierId,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getOrder: (id) => dispatch(getBrandOrder(id)),
  postReturns: (data, retailer_order_id, id) => dispatch(postBrandOrdersReturns(data, retailer_order_id, id)),
  setOffset: (offset) => dispatch(setBrandOrdersOffset(offset)),
  setPerPage: (offset) => dispatch(setBrandOrdersPerPage(offset)),
  filterById: (count) => dispatch(setBrandOrdersSearchById(count)),
  setSort: (order) => dispatch(setBrandOrdersSort(order)),
  cancelFulfillments: (ids) => dispatch(cancelFulfillments(ids)),
  downloadOrderDocuments: (orders) => dispatch(brandOrdersDownloadDocuments(orders)),
  getBrandOrdersAndFilters: (changeRetailers) => dispatch(getBrandOrdersAndFilters(changeRetailers)),
  fulfillOrder: (data, identifiers) => dispatch(fulfillOrder(data, identifiers)),
});

export default connect(mapStateToProps, mapDispatchToProps)(BrandOrdersContainer);

BrandOrdersContainer.propTypes = {
  data: PropTypes.array.isRequired,
  isLoading: PropTypes.bool.isRequired,
  cancelFulfillments: PropTypes.func.isRequired,
};
